---
fr:
  activerecord:
    attributes:
      api/key:
        company_ids: Accès aux entreprises
        description: Description
        name: Nom
        token: Token
      asset_comment:
        content: Message
        period: Période
        periods:
          monthly: Mensuel
          quarterly: Trimestriel
          yearly: Annuel
        power_plant_id: Centrale électrique
      bilateral_data:
        kaia_trade_metric_name: Nom de métrique Kaia Trade
        ownership_share: Part de propriété
      budget_forecast:
        avg_price: Prix moyen
        price_area: Zone de prix
        volume_percent: Pourcentage de production
      company:
        availability_analysis_enabled: Analyse de disponibilité activée
        benchmarking: Benchmarking activé
        business_id: ID d'entreprise
        commercial_scada_enabled: SCADA commercial activé
        detect_water_loss_downtime_enabled: Détection des pertes d'eau activée
        environmental_flow_tracking_enabled: Suivi du débit environnemental activé
        follow_up_enabled: Not translated
        liquidity_planning_enabled: Planification de la liquidité activée
        market_outlook_enabled: Perspectives du marché activées
        om_dashboard_enabled: Tableau de bord O&M activé
        ppa_pricing_enabled: Tarification PPA activée
        remove_logo: Supprimer le logo
        task_management_enabled: Gestion des tâches activée
        url_facebook: Facebook
        url_homepage: Site internet
        url_instagram: Instagram
        url_linked_in: LinkedIn
        white_labeling: Marque blanche activée
      company_responsible:
        power_plants: Centrales électriques
        responsible: Responsable
      contract:
        active: Actif
        counterpart: Contrepartie
        end_date: Date de fin du contrat
        open_ended: Contrat à durée indéterminée
        power_plant: Centrale électrique
        power_plants: Centrales électriques
        start_date: Date de début du contrat
        type: Type de contrat
      downtime_event:
        comment: Commentaire
        component: Composant principal
        ends_at: Fin de la période
        insurance: Réclamation d'assurance
        power_plant_id: Centrale
        reason: Raison
        starts_at: Début de la période
        total: Total
        verified: Vérifié
        volume: Production
        volume_hint: Capacité moyenne indisponible par heure
        volume_set_manually: Production entrée manuellement
        volume_should_have_been: Volume moyen attendu par heure au cours de la période
      event:
        active: actif
        alarm_categories: Catégories d'alarme
        component: Composant
        duration: Durée
        ends_at: À
        energy_loss_mwh: Énergie perdue (MWh)
        operational_status: Status opérationnel
        starts_at: De
        unavailable_power_kw: Puissance indisponible (kW)
        yield_loss: Pertes financières (%{currency})
      fall_lease:
        amount: Montant
        code: Code
        description: Description
        month: Mois
        owner: Propriétaire
        period: Période
        year: Année
      feature_request:
        author: Auteur
        category: Catégorie
        date: Date
        status: Statut
        title: Titre
        upvotes: Popularité
      feed_in_tariff_data:
        limit_type: Type de limite
        limit_types:
          fixed_price: Prix fixe
          price: Prix
        limit_value: Valeur limite
      hedging_data:
        limit_type: Type de limite
        limit_types:
          percent: Pourcentage
          volume: Volume
        limit_value: Valeur limite
        price: Prix
        strategies:
          monthly: Mensuel
          pay_as_produced: Pay as Produced
          quarterly: Trimestriel
          yearly: Annuel
        strategy: Stratégie
      hydro/asset:
        bypass_valve: Vanne de dérivation
        concession_date: Date de concession
        pipe_rupture_valve: Vanne de rupture de tuyau
        river_name: Rivière
        start_stop_power_fraction: Fraction de puissance démarrage/arrêt
        start_stop_power_fraction_hint: Variation de puissance (fraction de la puissance nominale) sur 15 min marquant un démarrage/arrêt
        winter_closed: Fermé en hiver
      hydro/environmental_flow_breakpoints:
        day: Jour
        flow: Débit
      hydro/generator:
        effect_limitation: Limitation externe
        efficiency_percent: Efficacité
        installed_capacity_mva: Capacité [MVA]
        power_factor_percent: Facteur de puissance
      hydro/intake:
        dam_length: Longueur du barrage [m]
        dam_width_streamwise: Largeur du barrage [m]
        intake_type: Type de prise d'eau
        lat: Latitude
        lng: Longitude
        lower_alert_limit: Limite d'alerte inférieure
        masl: Altitude de la prise d'eau
        trash_rack_cleaner: Dégrilleur automatique
        upper_alert_limit: Limite d'alerte supérieure
        upstream_depth: Profondeur en amont [m]
      hydro/model_param:
        bypass_max: Dérivation max
        bypass_min: Dérivation min
        continuous_dispatch: Dispatch continu
        discharge_max: Débit max
        discharge_min: Débit min
        energy_deviation_threshold: Seuil d'écart énergétique
        energy_equivalent: Équivalent énergétique
        net_head_masl_bound_max: Limite de hauteur de chute nette max (m)
        net_head_masl_bound_min: Limite de hauteur de chute nette min (m)
        overflow_protection: Protection contre le débordement
        p_max_overflow: Production max en débordement
        production_max: Production maximale
        production_min: Production minimale
        production_min_runtime_hours: Durée de fonctionnement à charge minimale
        production_sensitivity_max: Sensibilité de production max
        production_sensitivity_min: Sensibilité de production min
        resample_to: Rééchantillonner à
        reservoir_max_masl: Réservoir max (m)
        reservoir_min_masl: Réservoir min (m)
        reservoir_target_percentage: Objectif de réservoir
        runoff_scale_factor: Facteur d'échelle du ruissellement
        startup_override_production: Production de démarrage forcée
        use_runoff_data: Utiliser les données de ruissellement
      hydro/penstock:
        diameter: Diamètre
        length: Longueur
        material: Matériau
        net_head_loss_percent: Perte de charge nette
        risk_category: Catégorie de risque
      hydro/precipitation_field:
        aborigines: Peuples autochtones
        area: Surface
        avg_flow_area: Moyenne surface bassin versant
        field_length: Longueur du champ
        forest_size_percent: Taille de la forêt
        glacier_size_percent: Taille du glacier
        lat: Latitude
        lng: Longitude
        mountain_size_percent: Taille de la motagne
        sea_size_percent: Taille du lac
        swamp_size_percent: Taille du marais
      hydro/reservoir:
        artificial_reservoir: Réservoir artificiel
        gross_dammed_area: Surface de barrage brute
        gross_power_density: Densité de puissance brute
        highest_reservoir_value: Valeur maximale du réservoir
        lat: Latitude
        lng: Longitude
        lowest_reservoir_value: Valeur minimale du réservoir
        name: Nom
        net_dammed_area: Surface de barrage nette
        net_power_density: Densité de puissance nette
        reservoir_name: Nom du réservoir
        reservoir_volume: Volume du réservoir
        risk_category: Catégorie de risque
        surface_area: Surface
      hydro/river:
        anadromous_fish: Poisson anadrome
        name: Nom
        river_gradient: Pente de la rivière
        river_length: Longueur de la rivière
        watercourse: Cours d'eau
        watercourse_area: Surface du cours d'eau
      hydro/transformer:
        capacity_mva: Capacité [MVA]
        effect_limitation: Limitation de puissance
        efficiency_percent: Efficacité
      hydro/turbine:
        efficiency_percent: Efficacité (en conditions nominales)
        efficiency_percent_short: Efficacité
        installed_effect_mw: Capacité [MW]
        masl: Altitude de la turbine
        max_throughput_operational: Débit opérationnel maximal
        min_throughput_operational: Débit opérationnel minimal
        q_min_loss_percent: Perte Q min
        turbine_type: Type de turbine
      label:
        color: Couleur
        name: Nom
      news_item:
        accessible_by: Lié à
        allow_comments: Autoriser les commentaires
        author: Auteur
        body: Texte
        category: Catégorie
        community_access: Publication communautaire
        companies: Entreprises
        date: Date d'ajout
        image: Image
        image_position: Position de l'image
        include_subsidiaries: Inclure les filiales
        internal_post_landowner_access: Accès aux propriétaires fonciers
        portfolio_access: Portefeuille
        posts:
          one: Article
          other: Articles
        power_plants: Centrales
        title: Titre
      nve_metadata:
        building_type: Type de bâtiment
        building_types:
          surface: Superficiel
          surface_underground: Souterrain/Superficiel
          underground: Souterrain
        bypasswater_downstream_powerplant_label: Eaux de dérivation pour l'installation en aval (n° de ref. NVE)
        date_inital_utilization_of_waterfall: Date de la première utilisation de la chute d'eau
        date_oldest_power_producing_part: Date de l'unité de production d'électricité la plus ancienne
        energy_equivalent: Équivalent énergétique [kWh/m³]
        floodwater_downstream_powerplant_label: Eaux de crue pour l'installation en aval (n° de ref. NVE)
        min_throughput: Débit minimal
        min_throughput_unit: Débit minimal [m^3/s]
        nve_bypasswater_downstream_powerplant: Eaux de dérivation pour l'installation en aval
        nve_floodwater_downstream_powerplant: Eaux de crue pour l'installation en aval
        nve_production_downstream_powerplant: Production pour l'installation en aval
        powerplant_type: Type d'installation
        powerplant_types:
          reservoir: Centrales hydroélectrique à accumulation
          run_of_river: Centrales hydroélectrique au fil de l'eau
        precipitation_area: Surface de précipitation
        production_downstream_powerplant_label: Production pour l'installation en aval (n° de ref. NVE)
        regine_nr: N° Regine
        sp_nr_point_reference: N° SP point de référence
        sp_nr_watercourse: N° SP cours d'eau
      power_plant:
        absorption_capacity: Débit maximal
        asset_class: Classe d'actif
        axpo_id: ID Axpo
        bazefield_site_id: Bazefield site ID
        biodiversity_sensitive_areas: Zones biodiversité sensibles
        climate_future_ref: Référence Climate future
        co2_emission: Émission de CO2
        collect_weather: Collecter les données météorologiques
        commissioning_date: Date de mise en service
        company_id: Société
        company_name: Company name
        continuous_forecast_enabled: Prévision continue activée
        country_id: Pays
        county: Région
        county_name: Nom de la région
        datastream: Flux de données
        day_ahead_forecast_enabled: Prévision pour le lendemain activée
        downtime_analysis: Analyse de l'indisponibilité
        ecs_id: ID ECS
        elcert: Elcert
        elcert_ends_on: Fin d'Elcert
        elcert_starts_on: Début d'Elcert
        external_id: ID Nest
        forecast_query_enabled: Requête de prévision activé
        forecasted_budget: Budget prévu
        generator_capacity_mva: Capacité du générateur [MVA]
        go_date: Date d'expiration des GO
        greenbyte_site_id: Greenbyte site ID
        grid_owner: Propriétaire du réseau
        gurusoft_tags: Balises Gurusoft
        image: Télécharger une nouvelle image
        image_attribution: Attribution de l'image
        in_operation: En fonctionnement
        intake_count: Nombre de prises d'eau
        intake_lat_lng: Coordonnées prise d'eau
        internal_notes: Notes internes
        kaia_uuid: Identifiant unique de demande d'électricité Kaia
        krasys_live_measurement_values: KRASYS valeurs de mesure en direct
        kwh_m3: Équivalent énergie
        lat: Latitude
        lng: Longitude
        max_effect: Effet max. hist.
        max_throughput_operational: Débit opérationnel maximal
        metering_point_id: ID du point de mesure
        min_operational_power: Puissance opérationnelle minimale [MW]
        min_production_effect: Seuil d'indisponibilité [MW]
        min_throughput_operational: Débit opérationnel minimal
        model_parameters: Paramètres du modèle
        municipality: Municipalité
        municipality_name: Nom de la municipalité
        name: Nom
        net_head_masl: Chute nette de l'installation
        nispera_id: ID Nispera
        num_segments: Nombre de segments
        nve_gwh: Production annuelle
        nve_nr: Num. NVE
        nve_status: Statut
        optimization_model: Modèle d'optimisation
        owner: Propriétaire
        periods: Périodes
        plant_effect_mw: Capacité centrale [MW]
        postcode: Code postal
        price_area: Zone de prix
        price_dependent_bid_override: Remplacement d'enchère dépendant du prix
        production_simulation_plan_enabled: Plan de simulation de production activé
        project: Projet
        rated_power_mw: Capacité de la turbine [MW]
        remove_image: Supprimer l'image
        reservoir: Réservoir
        scada_int_id: Scada International ID
        scada_int_tag: Scada International tag
        settled_volume_source: Source de production officielle
        shadow_testing: Test en mode shadow
        shadow_tracking: Suivi fantôme
        site_address: Adresse du site
        station_lat_lng: Coordonnées de la station
        statkraft_customer_id: ID client Statkraft
        turbine_count: Nombre de turbines
        turbine_level_masl: Altitude de la turbine
        turbine_type: Type de turbine
        unsettled_volume_source: Source de volume non officielle
        use_price_dependent_bid: Offre dépendante du prix
        vertical_drop: Chute nette
        weather_source: Source météorologique
        wikipedia_page_id: ID de l'article Wikipedia
        xledger_project_id: Xledger ID du projet
        yearly_production: Production normale [GWh]
      power_plant_responsible:
        company_responsible: Responsable
        role_values:
          accounting: Comptabilité
          asset_manager: Gestionnaire d'actifs
          auditor: Auditeur
          balancing_responsible: Responsable de l'équilibrage
          ceo: CEO
          guarantees_of_origin_sales: Vente de garanties d'origine
          hv_leader: Responsable HT
          insurance_broker: Courtier d'assurance
          internal_grid_om: Maintenance du réseau interne
          internet_provider: Fournisseur d'accès à internet
          operator: Responsable d'exploitation
          owner_representative: Représentant du propriétaire
          plant_supervisor: Superviseur de l'installation
          road_maintenance: Entretien des routes
          snow_ploughing: Déneigement
          substation_om: Maintenance du poste électrique
          turbine_om: Maintenance de la turbine
          vta: TVA
          waste_management: Gestion des déchets
        roles: Rôles
      responsible:
        email: Adresse e-mail
        name: Nom
        phone: Téléphone
        user_id: Utilisateur
      scheduled_downtime_event:
        comment: Commentaire
        component: Composant principal
        curtailed_mode: Mode écourté
        ends_at: Fin de la période
        operator_email: E-mail de l'opérateur
        power_plant_id: Centrale
        reason: Raison
        starts_at: Début de la période
        volume: Production
        volume_hint: Capacité moyenne indisponible par heure
      self_consumption_data:
        currency_code: Devise
        generator_auxiliary_consumption_price_mwh: Coût de consommation des auxiliaires par MWh
        grid_injection_price_mwh: Rétribution d'injection réseau par MWh
        grid_injection_spot: Rétribution d'injection réseau au prix spot
        self_consumption_price_mwh: Rétribution d'autoconsommation par MWh
      sensor:
        lower_alert_limit: Limite d'alerte inférieure
        upper_alert_limit: Limite d'alerte supérieure
      solar/asset:
        anomaly_thresholds_help: 'Paramèters de détection des anomalies par défaut avec <code>&#123;&quot;idc&quot;:null,&quot;udc&quot;:null,&quot;fuac&quot;:null,&quot;min_gpoa_availability_wm2&quot;:60.0&#125;</code>.<br /> Configuration individuelle entièrement spécifiée à l''aide des paramètres par défaut :'
        anomaly_thresholds_raw: Seuils détection d'anomalies
        avg_yearly_solar_radiation: Rayonnement solaire annuel moyen
        data_source_settings_help: 'Paramètres de la source de données au format json. Paramètre obligatorie: <code>type</code> pour définir le type de source de données.<br /> Voir <a href="https://github.com/kaia/captiva_portal/wiki/Solar-data-source-settings.">Kaia portal wiki</a> pour les attributs complémentaires.<br /> Exemple pour Solar-Log FTP :'
        data_source_settings_raw: Paramètres source de données
        full_operating_hours: Heures de fonctionnement à pleine charge
        ml_learning_parameters_help: 'Paramètres minimaux sans substitution d''onduleurs ou de MPPT: <code>&#123;&quot;timestamp_from&quot;:&quot;2023-01-01T00:00:00Z&quot;,&quot;timestamp_to&quot;:&quot;2024-01-01T00:00:00Z&quot;,&quot;inv_replacements&quot;:[],&quot;mppt_replacements&quot;:[]&#125;</code>.<br /> Example impliquant une substitution de composants :'
        ml_learning_parameters_raw: Paramètres entraînement ML
        storage_unit_present: Batterie présente
        substation_lat: Latitude de la sous-station
        substation_lng: Longitude de la sous-station
        substation_masl: Altitude de la sous-station
      solar/field:
        installed_power_kwp: Puissance installée
        module_efficiency_percent: Efficacité du panneaux solaires
        mounting_mode: Type de montage
        mounting_modes:
          freestanding: Installation autonome (circulation d'air non restreinte)
          fully_insulated: Arrière totalement isolé
          intermediary: Intermédiaire (circulation d'air limitée)
        name: Nom
        orientation: Orientation
        tilt: Inclinaison
      solar/inverter:
        external_id: Mapping source de données
        installed_power_kwp: Puissance installée
        modules_count: Nombre de panneaux solaires
        name: Nom
        signal_mapping_raw: Signal mapping
        solar_inverter_type_id: Type d'onduleur
        valid_from: Valide depuis
        valid_to: Valide jusqu'à
      solar/inverter_type:
        maximal_power_kva: Puissance apparente maximale
        model: Désignation
        mppt_count: Number of MPPTs
        nominal_power_kw: Puissance active nominale
        supplier: Fabricant
        supplier_id: ID
      solar/model_param:
        production_max: Production maximale
        production_min: Production minimale
        production_sensitivity_max: Sensibilité de production max
        production_sensitivity_min: Sensibilité de production min
      solar/module_type:
        alpha_isc: Temperature Coefficient of ISC Alpha
        beta_uoc: Temperature Coefficient of Uoc Beta
        cell_type: Technologie de cellule
        cells_in_series: Cellules en série
        current_impp_a: MPP Current
        current_isc_a: Short-circuit Current
        gamma_pmpp: Temperature Coecient of Pmpp Gamma
        length_mm: Frame Length
        model: Désignation
        module_efficiency: Module efficiency
        noct_degc: Nominal Operating Cell Temperature NOCT
        power_pmpp_w: Nominal power
        supplier: Fabricant
        supplier_id: ID
        system_voltage_v: Maximum System Voltage
        voltage_umpp_v: MPP Voltage
        voltage_uoc_v: Open-circuit Voltage
        width_mm: Frame Width
      solar/mppt:
        input_number: Entrée
        installed_power_kwp: Puissance installée
        modules_efficiency: Efficacité du panneau
        modules_in_series: Panneaux en série
        modules_surface_m2: Surface des panneaux raccordés
        signal_mapping_raw: Attribution signaux
        solar_field_id: Champ
        solar_module_type_id: Panneau solaire
        source_name: Désignation données sources
        stringbox_name: SCB name
        strings_in_parallel: Strings en parallèle
      spot_data:
        ownership_share: Part de propriété
      supplier:
        add_new: Ajouter nouveau fournisseur
        category: Catégorie
        type: Type
        url_facebook: Facebook
        url_homepage: Site internet
        url_instagram: Instagram
        url_linked_in: LinkedIn
      user:
        avatar: Avatar
        avatar_lowercase: avatar
        company_ids: Entreprises
        currency_code: Devise
        email: Adresse e-mail
        firstname: Prénom
        job_title: Titre professionnel
        lastname: Nom de famille
        locale: Langue du portail
        news_email: Email d'information hebdomadaire
        password: Mot de passe
        password_confirmation: Confirmer le mot de passe
        phone: Téléphone fixe
        power_plant_ids: Centrales électriques
        short_bio: Biographie courte
      wind/asset:
        activity: Activité
        avg_yearly_wind_speed: Vitesse du vent moyenne annuelle
        data_source_settings_raw: Paramètres source de données
        full_operating_hours: Heures à pleine charge
        recycle_share_percent: Part de recyclage
        substation_lat: Lat sous-station
        substation_lng: Lon sous-station
        substation_masl: Altitude sous-station
      wind/availability_calculation:
        contractual_availability_calculation: Calcul de la disponibilité contractuelle
        contractual_availability_energy_based: Disponibilité contractuelle
        energy_based_availability: Disponibilité basée sur l'énergie
        time_based_availability: Disponibilité basée sur la durée
      wind/availability_mapping:
        alarm_category: Catégorie d'alarme
        alarm_category_types:
          environmental: Environnemental
          force_majeure: Force majeure
          grid: Réseau
          manufacturer: Fabricant
          no_data: Données manquantes
          owner: Propriétaire
          turbine_ok: Éolienne OK
        contractual_availability: Disponibilité contractuelle
        mapping_types:
          neglected: Ignoré
          ready: Disponible
          unavailable: Indisponible
        total_availability: Disponibilité totale
      wind/availability_target:
        contractual_availability_target: Objectif de disponibilité contractuelle
        year: Année
      wind/event_mappings:
        alarm_category_type: Catégorie d'alarme
        turbine_event_code: Code de l'événement éolienne
        turbine_event_name: Nom de l'événement éolienne
      wind/model_param:
        production_max: Production maximale
        production_min: Production minimale
        production_sensitivity_max: Sensibilité de production max
        production_sensitivity_min: Sensibilité de production min
      wind/power_curve:
        air_density_kgm3: Densité de l'air
        default: Défaut
        file: Fichier
        historical_power_curve: Courbe de puissance historique
        manufacturer_power_curve: Courbe de puissance fabricant
        name: Nom
        power: Puissance
        power_kw: Puissance [kW]
        show: Voir la courbe de puissance
        title: Courbe de puissance
        wind_speed: Vitesse du vent
        wind_speed_ms: Vitesse du vent [m/s]
      wind/turbine:
        commissioning_year: Année de mise en service
        external_source_id: ID source de données
        ground_altitude_masl: Altitude du terrain
        hub_height: Hauteur de la nacelle
        lat: Latitude
        lng: Longitude
        name: Nom
        tip_height: Hauteur de la pointe des pales
        wind_turbine_type_id: Type de turbine
      wind/turbine_type:
        meteomatics_id: ID de turbine Meteomatics
        name: Nom
        rated_power_kw: Puissance nominale [kW]
        rotor_diameter: Diamètre du rotor [m]
        supplier_id: ID
      work_item:
        budget_cost: Coûts budgétaire
        closed_on: Terminé le
        company_responsible: Responsable
        component: Composant
        description: Description
        due_date: Délai
        elapsed_cost: Coûts engendrés
        forecast_cost: Coûts estimé
        id: ID
        labels: Étiquettes
        last_comment: Dernier commentaire
        power_plant: Centrale électrique
        started_on: Commencé le
        status: Status
        title: Titre
        valuta: Devise
    errors:
      models:
        budget_forecast:
          volume_forecast: doit être compris entre 0 et 100
        contract:
          too_long: Doit être une seule centrale électrique
        event:
          cannot_change_component_or_operation_status_settled: Impossible de modifier le composant ou l'operational_status_id d'un événement confirmé et non terminé
          cannot_delete_settled: Impossible de supprimer un événement confirmé
          cannot_modify_locked_event: Impossible de modifier un événement verrouillé
          cannot_overlap: Le chevauchement d'événements pour le même composant n'est pas autorisé
          cannot_update_settled: Impossible de mettre à jour un événement confirmé/terminé
        market_paramaeter:
          bids_illogical: Le prix de l'offre minimale ne peut pas être plus élevée que celui de l'offre maximale
    models:
      elcert_month:
        one: Mois Elcert
        other: Mois Elcert
      go_month:
        one: Mois GO
        other: Mois GO
